/// <amd-module name="Build/Common/Artifacts/providers/PipelineArtifact" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes, ArtifactProviderContext } from 'Common';

import { BuildArtifact } from 'Build/Client/Contracts/Build';

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";


export class PipelineArtifact extends Base {

    constructor(
        pageContext: IVssPageContext,
        artifact: BuildArtifact,
        providerContext: ArtifactProviderContext) {
        super(pageContext, artifact, providerContext);
    }

    public getKey() {
        return BuildArtifactTypes.PipelineArtifact;
    }

    public supportsDownload(): boolean {
        return true;
    }

    public supportsExploring(): boolean {
        return true;
    }

    public getDownloadURL(): string {
        let url: string = this.artifact.resource.downloadUrl;

        return url;
    }
}
